import axios from "axios";

export default axios.create({
    // baseURL: 'https://mughalbackend.vercel.app',
    // baseURL: 'https://mughalbackend.vercel.app',
    // baseURL: 'http://167.99.245.133:4992',
    // baseURL: 'http://138.68.154.74:4992',
    baseURL: 'https://mughalbackend.oxmite.com',
    
})